var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveSquareOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "none",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m432 0h-352c-44.160156.0546875-79.9453125 35.839844-80 80v352c.0546875 44.160156 35.839844 79.945312 80 80h352c44.160156-.054688 79.945312-35.839844 80-80v-352c-.054688-44.160156-35.839844-79.9453125-80-80zm48 432c0 26.507812-21.492188 48-48 48h-352c-26.507812 0-48-21.492188-48-48v-352c0-26.507812 21.492188-48 48-48h352c26.507812 0 48 21.492188 48 48zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m380.449219 108.929688-124.449219 124.445312-124.449219-124.445312-22.621093 22.621093 124.445312 124.449219-124.445312 124.449219 22.621093 22.621093 124.449219-124.445312 124.449219 124.445312 22.621093-22.621093-124.445312-124.449219 124.445312-124.449219zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSquareOutline);
export default __webpack_public_path__ + "static/media/remove-square-outline.e1c9eb590716d62139247dd5e6d7941f.svg";
export { ForwardRef as ReactComponent };